import { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { WidgetContainer } from '@pulse-web-ui/containers';
import { Act } from '@pulse-web-ui/icons';
import { useTheme } from '@pulse-web-ui/theme';
import { observer } from 'mobx-react-lite';

import {
  AgentDocumentType,
  WidgetHeader,
  addTestAttribute,
  useOpenFile,
  useStores,
} from '@shared/index';

import { type GetDocumentRequestParams, useGetDocument } from '../../api';
import { DocumentItem, FlexContainer, Value } from './profile.documents.styles';

export const ProfileDocuments = observer(() => {
  const { t } = useTranslation();
  const theme = useTheme();
  const [requestParams, setRequestParams] = useState<GetDocumentRequestParams>({
    searchParameters: {
      agentDocumentType: AgentDocumentType.DOCUMENT,
      fileId: '',
    },
  });
  const {
    MainStore: {
      agentContractStore: { agentDocuments },
    },
  } = useStores();
  const { res, isFetching, refetch, error } = useGetDocument(requestParams, [
    requestParams,
  ]);

  const onOpenFile = useOpenFile({
    res,
    isFetching,
    error,
  });

  const handleDocumentDownload = (
    documentType: AgentDocumentType,
    id: string
  ) => {
    onOpenFile();
    setRequestParams({
      searchParameters: { agentDocumentType: documentType, fileId: id },
    });
  };

  useEffect(() => {
    if (requestParams.searchParameters.fileId) {
      refetch();
    }
  }, [requestParams]);

  return (
    <WidgetContainer>
      <WidgetHeader $marginBottom={12}>
        {t('AGENT_PROFILE:headers.documents')}
      </WidgetHeader>
      <FlexContainer>
        {!!agentDocuments?.length &&
          agentDocuments.map(({ description, agentDocumentType, fileId }) => (
            <DocumentItem
              key={`${description}-${fileId}`}
              onClick={() => handleDocumentDownload(agentDocumentType, fileId)}
              {...addTestAttribute(`agent-document-${fileId}`)}
            >
              <Act
                color={theme.colors.icon.primary}
                width={20}
              />
              <Value>{description}</Value>
            </DocumentItem>
          ))}
      </FlexContainer>
    </WidgetContainer>
  );
});
